import { PlanningConstraints } from './planning.types';

/** Wall dates use UTC components for arithmetic, matching SQL DATETIME across DST. */
export function planningTime(value: string, basis: PlanningConstraints['time_basis']): number {
    if (typeof value !== 'string') throw new Error('A planning date must be a string.');
    if (basis === 'instant') {
        if (!/(Z|[+-]\d{2}:\d{2})$/.test(value)) throw new Error('Instant planning dates require an explicit UTC offset.');
        const time = Date.parse(value);
        if (!Number.isFinite(time)) throw new Error('Invalid planning date: ' + value);
        return time;
    }
    const parts = /^(\d{4})-(\d{2})-(\d{2})[ T](\d{2}):(\d{2}):(\d{2})(?:\.(\d{1,3}))?$/.exec(value);
    if (!parts) throw new Error('Wall planning dates require YYYY-MM-DD HH:mm:ss without a UTC offset.');
    const [year, month, day, hour, minute, second] = parts.slice(1, 7).map(Number);
    const date = new Date(0);
    date.setUTCFullYear(year, month - 1, day);
    date.setUTCHours(hour, minute, second, Number((parts[7] ?? '').padEnd(3, '0')));
    if (date.getUTCFullYear() !== year || date.getUTCMonth() !== month - 1 || date.getUTCDate() !== day || date.getUTCHours() !== hour || date.getUTCMinutes() !== minute || date.getUTCSeconds() !== second) throw new Error('Invalid planning date: ' + value);
    return date.getTime();
}

export function planningDate(time: number, basis: PlanningConstraints['time_basis']): string {
    const iso = new Date(time).toISOString();
    return basis === 'instant' ? iso : iso.slice(0, -1).replace('T', ' ');
}

export function planningDateToDate(value: string, basis: PlanningConstraints['time_basis']): Date {
    const date = new Date(planningTime(value, basis));
    if (basis === 'instant') return date;
    const local = new Date(0);
    local.setFullYear(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate());
    local.setHours(date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds(), date.getUTCMilliseconds());
    return local;
}

export function planningDateFromDate(date: Date, basis: PlanningConstraints['time_basis']): string {
    if (basis === 'instant') return date.toISOString();
    const wall = new Date(0);
    wall.setUTCFullYear(date.getFullYear(), date.getMonth(), date.getDate());
    wall.setUTCHours(date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds());
    return planningDate(wall.getTime(), basis);
}
